import { render, staticRenderFns } from "./AssetComponent.vue?vue&type=template&id=5cfc8fd4&scoped=true"
import script from "./AssetComponent.vue?vue&type=script&lang=js"
export * from "./AssetComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc8fd4",
  null
  
)

export default component.exports